// ERP API client - all routes prefixed with /api/erp
import client from './api';

const erp = (path) => `/erp${path}`;

// Users
export const apiToggleErpAccess = async (userId, erp_access) =>
  (await client.put(erp(`/users/${userId}/erp-access`), { erp_access })).data;

// Partners
export const apiListPartners = async (params = {}) => (await client.get(erp('/partners'), { params })).data;
export const apiCreatePartner = async (data) => (await client.post(erp('/partners'), data)).data;
export const apiGetPartner = async (id) => (await client.get(erp(`/partners/${id}`))).data;
export const apiUpdatePartner = async (id, data) => (await client.put(erp(`/partners/${id}`), data)).data;
export const apiDeletePartner = async (id) => (await client.delete(erp(`/partners/${id}`))).data;

// Products
export const apiListProducts = async (params = {}) => (await client.get(erp('/products'), { params })).data;
export const apiCreateProduct = async (data) => (await client.post(erp('/products'), data)).data;
export const apiUpdateProduct = async (id, data) => (await client.put(erp(`/products/${id}`), data)).data;
export const apiDeleteProduct = async (id) => (await client.delete(erp(`/products/${id}`))).data;

// Warehouses & Locations
export const apiListWarehouses = async () => (await client.get(erp('/warehouses'))).data;
export const apiCreateWarehouse = async (data) => (await client.post(erp('/warehouses'), data)).data;
export const apiUpdateWarehouse = async (id, data) => (await client.put(erp(`/warehouses/${id}`), data)).data;
export const apiDeleteWarehouse = async (id) => (await client.delete(erp(`/warehouses/${id}`))).data;
export const apiListLocations = async (warehouse_id) => {
  const params = warehouse_id ? { warehouse_id } : {};
  return (await client.get(erp('/locations'), { params })).data;
};
export const apiCreateLocation = async (data) => (await client.post(erp('/locations'), data)).data;
export const apiUpdateLocation = async (id, data) => (await client.put(erp(`/locations/${id}`), data)).data;
export const apiDeleteLocation = async (id) => (await client.delete(erp(`/locations/${id}`))).data;

// Stock
export const apiCreateMovement = async (data) => (await client.post(erp('/stock/movements'), data)).data;
export const apiListMovements = async (params = {}) => (await client.get(erp('/stock/movements'), { params })).data;
// Export Giacenze (XLSX/PDF) usando gli stessi filtri server-side
export const apiExportStockByProduct = async (format = 'xlsx', filters = {}) => {
  const params = { format, ...filters };
  const resp = await client.get(erp('/stock/by-product/export'), { params, responseType: 'blob' });
  const ext = format === 'pdf' ? 'pdf' : 'xlsx';
  const mime = format === 'pdf' ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  const today = new Date().toISOString().slice(0, 10);
  const filename = `giacenze_${today}.${ext}`;
  const url = URL.createObjectURL(new Blob([resp.data], { type: mime }));
  const a = document.createElement('a');
  a.href = url; a.download = filename; document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
  return filename;
};

export const apiListStock = async (params = {}) => (await client.get(erp('/stock'), { params })).data;
export const apiStockAlerts = async () => (await client.get(erp('/stock/alerts'))).data;
export const apiStockByProduct = async (params = {}) => (await client.get(erp('/stock/by-product'), { params })).data;

// BOM
export const apiListBoms = async (params = {}) => {
  const p = typeof params === 'string' ? { product_id: params } : (params || {});
  return (await client.get(erp('/boms'), { params: p })).data;
};
export const apiCreateBom = async (data) => (await client.post(erp('/boms'), data)).data;
export const apiUpdateBom = async (id, data) => (await client.put(erp(`/boms/${id}`), data)).data;
export const apiDeleteBom = async (id) => (await client.delete(erp(`/boms/${id}`))).data;

// Production Orders
export const apiCreatePOrder = async (data) => (await client.post(erp('/production-orders'), data)).data;
export const apiListPOrders = async (params = {}) => (await client.get(erp('/production-orders'), { params })).data;
export const apiGetPOrder = async (id) => (await client.get(erp(`/production-orders/${id}`))).data;
export const apiUpdatePOrder = async (id, data) => (await client.put(erp(`/production-orders/${id}`), data)).data;
export const apiClosePOrder = async (id, data) => (await client.post(erp(`/production-orders/${id}/close`), data)).data;

// Documents
export const apiCreateDocument = async (data) => (await client.post(erp('/documents'), data)).data;
export const apiListDocuments = async (params = {}) => (await client.get(erp('/documents'), { params })).data;
export const apiGetDocument = async (id) => (await client.get(erp(`/documents/${id}`))).data;
export const apiUpdateDocument = async (id, data) => (await client.put(erp(`/documents/${id}`), data)).data;
export const apiDeleteDocument = async (id) => (await client.delete(erp(`/documents/${id}`))).data;
export const apiConvertDocument = async (id, target_type) =>
  (await client.post(erp(`/documents/${id}/convert`), { target_type })).data;
// DDT — PF disponibili da OL completati & conferma/annulla spedizione
export const apiDdtAvailableForCustomer = async (customer_id, warehouse_id = null) => {
  const params = { customer_id };
  if (warehouse_id) params.warehouse_id = warehouse_id;
  return (await client.get(erp('/ddt/available-for-customer'), { params })).data;
};
export const apiConfirmDdtShipment = async (id) =>
  (await client.post(erp(`/documents/${id}/confirm-shipment`))).data;
export const apiCancelDdtShipment = async (id) =>
  (await client.post(erp(`/documents/${id}/cancel-shipment`))).data;
export const apiDocumentPdfUrl = (id, download = false) => {
  const base = process.env.REACT_APP_BACKEND_URL;
  return `${base}/api/erp/documents/${id}/pdf${download ? '?download=true' : ''}`;
};
// Helper: fetch blob and open it in new tab via anchor (works around popup blocker)
const openBlobInTab = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.target = '_blank';
  a.rel = 'noopener noreferrer';
  if (filename) a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
};

// Open PDF in new tab (auth-aware: fetches via authed client and creates a Blob URL)
export const apiOpenDocumentPdf = async (id) => {
  const resp = await client.get(erp(`/documents/${id}/pdf`), { responseType: 'blob' });
  openBlobInTab(new Blob([resp.data], { type: 'application/pdf' }));
};
export const apiDownloadDocumentPdf = async (id, filename) => {
  const resp = await client.get(erp(`/documents/${id}/pdf`), { params: { download: true }, responseType: 'blob' });
  const blob = new Blob([resp.data], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename; document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
export const apiDeletePOrder = async (id, force = false) =>
  (await client.delete(erp(`/production-orders/${id}`), { params: force ? { force: true } : {} })).data;
export const apiProductionOrderPdfUrl = (id, download = false) => {
  const base = process.env.REACT_APP_BACKEND_URL;
  return `${base}/api/erp/production-orders/${id}/pdf${download ? '?download=true' : ''}`;
};
export const apiOpenProductionOrderPdf = async (id) => {
  const resp = await client.get(erp(`/production-orders/${id}/pdf`), { responseType: 'blob' });
  openBlobInTab(new Blob([resp.data], { type: 'application/pdf' }));
};
// Distinta Base (BOM) PDF da ordine di lavoro
export const apiOpenProductionOrderBomPdf = async (id) => {
  const resp = await client.get(erp(`/production-orders/${id}/bom-pdf`), { responseType: 'blob' });
  openBlobInTab(new Blob([resp.data], { type: 'application/pdf' }));
};
export const apiDownloadProductionOrderBomPdf = async (id, filename) => {
  const resp = await client.get(erp(`/production-orders/${id}/bom-pdf`), { params: { download: true }, responseType: 'blob' });
  const blob = new Blob([resp.data], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename; document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
export const apiDownloadProductionOrderPdf = async (id, filename) => {
  const resp = await client.get(erp(`/production-orders/${id}/pdf`), { params: { download: true }, responseType: 'blob' });
  const blob = new Blob([resp.data], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename; document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

// Labels
export const apiLabelPdfUrl = (productId, qty = 1) => {
  const base = process.env.REACT_APP_BACKEND_URL;
  return `${base}/api/erp/labels/product/${productId}?qty=${qty}&format=pdf`;
};
export const apiOpenProductLabel = async (productId, qty = 1) => {
  const resp = await client.get(erp(`/labels/product/${productId}`), { params: { qty, format: 'pdf' }, responseType: 'blob' });
  openBlobInTab(new Blob([resp.data], { type: 'application/pdf' }));
};
export const apiLabelZpl = async (productId, qty = 1) => {
  const resp = await client.get(erp(`/labels/product/${productId}`), { params: { qty, format: 'zpl' }, responseType: 'text' });
  return resp.data;
};

// Dashboard
export const apiErpDashboard = async () => (await client.get(erp('/dashboard'))).data;

// Inventory (riconciliazione fisica)
export const apiCreateInventory = async (data) => (await client.post(erp('/inventory/sessions'), data)).data;
export const apiListInventories = async (params = {}) => (await client.get(erp('/inventory/sessions'), { params })).data;
export const apiGetInventory = async (id) => (await client.get(erp(`/inventory/sessions/${id}`))).data;
export const apiUpdateInventoryLine = async (id, lineId, data) =>
  (await client.put(erp(`/inventory/sessions/${id}/lines/${lineId}`), data)).data;
export const apiConfirmInventory = async (id) => (await client.post(erp(`/inventory/sessions/${id}/confirm`))).data;
export const apiCancelInventory = async (id) => (await client.post(erp(`/inventory/sessions/${id}/cancel`))).data;
export const apiDeleteInventory = async (id) => (await client.delete(erp(`/inventory/sessions/${id}`))).data;
